import PropTypes from 'prop-types';
import { getFacetLink } from '../../FacetsLink/facetLinkUtils';
import { styles } from './FacetWithLink.style';
import { facetClick } from '../FacetEvents';

const FacetWithLink = ({ isLink, canonicalUrl, option, children }) => {
  if (!(isLink && canonicalUrl)) {
    return children;
  }
  const handleClick = (event) => {
    event.preventDefault();
    facetClick();
  };
  const facetLink = getFacetLink(canonicalUrl, option);
  return (
    <a href={facetLink} className="facet-link" onClick={handleClick} data-testid="facet-link">
      {children}
      <style jsx>{styles}</style>
    </a>
  );
};

FacetWithLink.propTypes = {
  isLink: PropTypes.bool,
  canonicalUrl: PropTypes.string,
  option: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

FacetWithLink.defaultProps = {
  isLink: false,
  canonicalUrl: '',
};

export { FacetWithLink };
